import {atom} from 'jotai';

export const confettiTrackerAtom = atom<{
  [user_id: string]: boolean;
}>({});
